import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {isNullOrUndefined} from "util";
import {Subscriber} from "rxjs/Subscriber";
import {cloneDeep} from "lodash"
import {AttachmentService, AttachmentType} from "../../../../../../../clients/app/modules/+registration/api/index";
import {AttachmentItem} from "../../api/entity/index";
import {DictionaryObject} from "../../../../../../../common/api/index";
import {ModalService} from "../../../../../shared/modal/modal.service";
import {NotificationManager} from "../../../../../../../common/providers/notification/index";
import {FileUploadConfig} from "../../../../../../../clients/app/config";
import {MAX_UPLOAD_FILE_SIZE} from "../../../../../../../common/constants";

@Component({
    selector: 'tfl-file-upload-modal',
    template: require('./file.upload.modal.template.html'),
})
export class FileUploadModalComponent implements OnInit {

    @Input() fileUploadModalId: string;
    @Input() attachmentType: AttachmentType;
    @Output() saveButtonAction: EventEmitter<any> = new EventEmitter();

    @Input('settings') settings: FileUploadConfig = {
        allowedMaxFileSize: MAX_UPLOAD_FILE_SIZE,
        allowedMimeTypes: {
            'application/pdf': '.pdf',
            'image/png': '.png',
            'image/jpeg': '.jpeg',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
        },
        allowedMaxCountAttachments: 0,
    };

    files: AttachmentItem[] = [];
    attachmentTypes: DictionaryObject[] = [];

    loadingState: boolean = false;

    constructor(private _modalService: ModalService,
                private _notificationManager: NotificationManager,
                private _translateService: TranslateService,
                private _attachmentService: AttachmentService) {
    }

    ngOnInit() {
        this.loadAttachmentTypes();
    }

    loadAttachmentTypes() {
        this.loadingState = true;
        this._attachmentService.getAttachmentTypes(this.attachmentType)
            .subscribe(attachmentTypes => {
                this.attachmentTypes = cloneDeep(attachmentTypes);
                this.loadingState = false;
            });
    }

    removeFile(id): void {
        this.files =
            this.files.filter((file) => id !== file.id);
    }

    show() {
        this.reset();
        this._modalService.open(this.fileUploadModalId);
    }

    dismiss() {
        this.reset();
        this.closeModal();
    }

    uploadFile(event): void {
        let file = event.target.files[0];
        event.target.value = '';
        if (isNullOrUndefined(file) || this.files.findIndex(f => f.name == file.name) != -1) {
            event.target.value = null;
            return;
        }
        if (file.size > this.settings.allowedMaxFileSize) {
            this._notificationManager.error(this._translateService.instant('APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.UPLOAD.ERROR.MAX_SIZE'));
            event.target.value = null;
            return;
        }
        if (!this.isMimeTypeAllowed(file.type)) {
            this._notificationManager.error(this._translateService.instant('APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.UPLOAD.ERROR.UNSUPPORTED_FORMAT'));
            event.target.value = null;
            return;
        }

        this._attachmentService.attach(file, this.attachmentType, Subscriber.create(() => {
        })).subscribe(
            id => {
                this.files.push({
                    id: id,
                    name: file.name,
                    attachmentTypeId: this.attachmentTypes[0].id
                })
            }
        );
    }

    private isMimeTypeAllowed(mimeType: string): boolean {
        const {allowedMimeTypes} = this.settings;
        const mimeTypes = Object.keys(allowedMimeTypes);
        return mimeTypes.indexOf(mimeType) > -1;
    }

    save() {
        this.saveButtonAction.emit(this.files);
        this.reset();
        this.closeModal();
    }

    closeModal() {
        this._modalService.close(this.fileUploadModalId);
    }

    private reset(): void {
        this.files = [];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/file.upload.modal/file.upload.modal.component.ts